/**
 * 音频管理器：使用 Web Audio API 合成音效
 */
class AudioManager {
  constructor() {
    this.ctx = null;
    this.isBgmPlaying = false;
  }

  init() {
    if (!this.ctx) {
      this.ctx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (this.ctx.state === 'suspended') {
      this.ctx.resume();
    }
  }

  startBGM() {
    if (!this.ctx || this.isBgmPlaying) return;
    this.isBgmPlaying = true;
    
    const playNote = (freq, time, duration, type = 'square') => {
      const osc = this.ctx?.createOscillator();
      const g = this.ctx?.createGain();
      osc.type = type;
      osc.frequency.setValueAtTime(freq, time);
      g.gain.setValueAtTime(0.01, time);
      g.gain.exponentialRampToValueAtTime(0.001, time + duration);
      osc.connect(g);
      g.connect(this.ctx?.destination);
      osc.start(time);
      osc.stop(time + duration);
    };

    const loop = () => {
      if (!this.isBgmPlaying) return;
      const now = this.ctx?.currentTime;
      const scale = [261.63, 329.63, 392.00, 523.25]; // C大调音阶
      for (let i = 0; i < 8; i++) {
        const note = scale[Math.floor(Math.random() * scale.length)];
        const delay = i * 0.25;
        playNote(note, now + delay, 0.2, 'square');
        if (i % 4 === 0) {
          playNote(55, now + delay, 0.1, 'sine');
        }
      }
      setTimeout(loop, 2000);
    };
    loop();
  }

  playJump() {
    if (!this.ctx) return;
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(400, this.ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(1200, this.ctx.currentTime + 0.1);
    gain.gain.setValueAtTime(0.1, this.ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, this.ctx.currentTime + 0.1);
    osc.connect(gain);
    gain.connect(this.ctx.destination);
    osc.start();
    osc.stop(this.ctx.currentTime + 0.1);
  }

  playCollect() {
    if (!this.ctx) return;
    const now = this.ctx.currentTime;
    const freqs = [1046.50, 1318.51]; // C6, E6
    freqs.forEach((f, i) => {
      const osc = this.ctx?.createOscillator();
      const gain = this.ctx?.createGain();
      osc.type = 'triangle';
      osc.frequency.setValueAtTime(f, now + i * 0.05);
      gain.gain.setValueAtTime(0.08, now + i * 0.05);
      gain.gain.exponentialRampToValueAtTime(0.01, now + i * 0.05 + 0.1);
      osc.connect(gain);
      gain.connect(this.ctx?.destination);
      osc.start(now + i * 0.05);
      osc.stop(now + i * 0.05 + 0.1);
    });
  }

  playCrash() {
    if (!this.ctx) return;
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(100, this.ctx.currentTime);
    osc.frequency.linearRampToValueAtTime(30, this.ctx.currentTime + 0.5);
    gain.gain.setValueAtTime(0.15, this.ctx.currentTime);
    gain.gain.linearRampToValueAtTime(0.01, this.ctx.currentTime + 0.5);
    osc.connect(gain);
    gain.connect(this.ctx.destination);
    osc.start();
    osc.stop(this.ctx.currentTime + 0.5);
  }

  playLevelClear() {
    if (!this.ctx) return;
    const melody = [523.25, 659.25, 783.99, 1046.50];
    melody.forEach((freq, i) => {
      const osc = this.ctx?.createOscillator();
      const gain = this.ctx?.createGain();
      osc.type = 'square';
      osc.frequency.setValueAtTime(freq, this.ctx?.currentTime + i * 0.1);
      gain.gain.setValueAtTime(0.05, this.ctx?.currentTime + i * 0.1);
      gain.gain.exponentialRampToValueAtTime(0.01, this.ctx?.currentTime + i * 0.1 + 0.4);
      osc.connect(gain);
      gain.connect(this.ctx?.destination);
      osc.start(this.ctx?.currentTime + i * 0.1);
      osc.stop(this.ctx?.currentTime + i * 0.1 + 0.4);
    });
  }

  playTick() {
    if (!this.ctx) return;
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, this.ctx.currentTime);
    gain.gain.setValueAtTime(0.05, this.ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, this.ctx.currentTime + 0.05);
    osc.connect(gain);
    gain.connect(this.ctx.destination);
    osc.start();
    osc.stop(this.ctx.currentTime + 0.05);
  }
}

export const audioManager = new AudioManager();
